cbp-flex-item:not([hidden]) {
  display: block;
}